import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import BannersList from '../../components/BannersList';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadHelp } from '../../actions/HelpActions';

class PageHelp extends Component {
  static requestData(store) {
    return requestAll([loadHelp], store);
  }
  componentDidMount() {
    this.props.actions.loadHelp();
  }
  render() {
    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      <div className="container container--indentVertical">
        <Helmet>
          <meta name="description" content="Как пройти собеседование и устроиться на хорошую работу. Рассказывает специалист по подбору!" />
        </Helmet>
        <div className="row">
          <div className="col col--8 colTablet--12">
            <h1 className="text text--h1">{this.props.help.name}</h1>
            <div className="text">
              {
                !(this.props.help.content === undefined) &&
                <dl>
                  {
                    this.props.help.content.map((item, index) => (
                      [
                        <dt key={`dl-${index}`}>{item.title}</dt>,
                        <dd key={`dd-${index}`} dangerouslySetInnerHTML={{ __html: item.content}}/>
                      ]
                    ))
                  }
                  </dl>
              }
            </div>
          </div>
          <div className="col col--4 colTablet--12">
            <BannersList random vertical />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      help: state.help.item,
      hasErrored: state.help.hasErrored,
      isLoading: state.help.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadHelp }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageHelp));



// WEBPACK FOOTER //
// ./src/pages/PageHelp/index.js